import React from "react";
import { Document, Page, Text, View, StyleSheet, Image } from "@react-pdf/renderer";
import logo from '../../assets/images/logo.png';
import moment from "moment";

const styles = StyleSheet.create({
  Page: {
    padding: 30,
    backgroundColor: "#ffffff",
  },
  Header: {
    display: "flex",
    flexDirection: 'row',
    justifyContent: "space-between",
    alignItems: "center"
  },
  Logo: {
    width: 50,
    height: 50,
    objectFit: "contain",
  },
  Title: {
    fontSize: 18,
    fontFamily: 'Helvetica-Bold',
    color: "#000000",
    fontWeight: "bold",
  },
  TableRow: {
    display: "flex",
    flexDirection: 'row',
  },
  Bold: {
    fontFamily: 'Helvetica-Bold',
    fontWeight: "bold"
  },
  Text: {
    fontSize: 10,
    fontFamily: 'Helvetica',
  },
  MediumText: {
    fontSize: 14,
  },
  TextRight: {
    textAlign: "right",
  },
  InvoiceDetails: {
    display: "flex",
    justifyContent: "space-between",
    marginTop: 30,
  },
  AddressRow: {
    display: "flex",
    flexDirection: 'row',
    flexWap: "wrap",
    marginTop: 30,
  },
  AddressCol: {
    flex: 1
  },
  Table: {
    display: "flex",
    flexDirection: "column",
    marginTop: 30,
  },
  Row: {
    display: "flex",
    flexDirection: "row",
    borderBottom: "1px solid #e0e0e0",
    padding: "5px 0",
  },
  Cell: {
    width: "25%",
    paddingTop: 5,
    paddingBottom: 5,
  },
  TotalSection: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
    width: "100%"
  },
  SectionRow: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    borderBottom: "1px solid #e0e0e0",
    padding: "7px 0",
  },
  AmountDueBlock: {
    marginTop: "30px"
  },
  Width50: {
    width: '50%'
  },
  Width20: {
    width: '20%'
  },
  Width10: {
    width: '10%'
  },
  Mb5: {
    marginBottom: 5,
  },
  Footer: {
    position: "absolute",
    fontSize: 8,
    bottom: 0,
    left: 0,
    right: 0,
    paddingTop: 10,
    paddingBottom: 10,
    borderTop: "1px solid #e0e0e0",
    textAlign: "center",
    color: "#555"
  },
});

const Invoice = ({ invoiceData }) => {
  const currency = invoiceData?.currency?.toUpperCase() || "USD";
  const { fee_amount, gross_amount, net_amount } = invoiceData?.moreData?.amount_with_breakdown;
  const { title, amount, interval } = invoiceData?.moreData?.dbDetails;
  const { shipping_address, name, email_address } = invoiceData?.moreData?.subscriptionById?.subscriber;

  const CustomerAddress = ({ address, name, email }) => (
    <View style={styles.AddressCol}>
      <Text style={[styles.Text, styles.Bold, styles.Mb5]}>Bill To</Text>
      {name && <Text style={styles.Text}>{name.given_name} {name.surname}</Text>}
      {address?.address_line_1 && <Text style={styles.Text}>{address.address_line_1}</Text>}
      {address?.admin_area_1 && <Text style={styles.Text}>{address.admin_area_1}</Text>}
      {address?.admin_area_2 && <Text style={styles.Text}>{address.admin_area_2}</Text>}
      {address?.country_code && <Text style={styles.Text}>{address.country_code}</Text>}
      {address?.postal_code && <Text style={styles.Text}>{address.postal_code}</Text>}
    </View>
  );


  return (
    <Document>
      <Page style={styles.Page}>
        <View style={styles.Header}>
          <Text style={styles.Title}>Invoice</Text>
          <Image style={styles.Logo} source={{ uri: logo }} />
        </View>

        <View style={styles.InvoiceDetails}>
          <View>
            <View style={[styles.TableRow, styles.Mb5]}>
              <Text style={[styles.Text, styles.Bold, styles.Width20]}>Invoice Number</Text>
              <Text style={[styles.Text, styles.Bold]}>{invoiceData?.id || "N/A"}</Text>
            </View>
            <View style={[styles.TableRow, styles.Mb5]}>
              <Text style={[styles.Text, styles.Width20]}>Date of Issue</Text>
              <Text style={styles.Text}>{invoiceData?.start_time ? moment.unix(invoiceData?.start_time).format('MMMM DD, YYYY') : "N/A"}</Text>
            </View>
            {invoiceData?.end_time && (
              <View style={[styles.TableRow, styles.Mb5]}>
                <Text style={[styles.Text, styles.Width20]}>Date Due</Text>
                <Text style={styles.Text}>{moment.unix(invoiceData?.end_time).format('MMMM DD, YYYY')}</Text>
              </View>
            )}
          </View>
          <View style={styles.AddressRow}>
            <View style={styles.AddressCol}>
              <Text style={[styles.Text, styles.Bold, styles.Mb5]}>traveyclub.com</Text>
              <Text style={styles.Text}>80 Coronation Rd</Text>
              <Text style={styles.Text}>Baulkham Hills NSW 2153, Australia</Text>
              <Text style={styles.Text}>Sydney New South Wales 2153</Text>
              <Text style={styles.Text}>Australia</Text>
              <Text style={styles.Text}>61 433 168 265</Text>
            </View>
            {shipping_address ? (
              <CustomerAddress
                address={shipping_address?.address}
                name={name}
                email={email_address}
              />
            ) : ("")}

          </View>
        </View>

        {/* <View style={styles.AmountDueBlock}>
          <Text style={[styles.MediumText, styles.Bold]}>
            {currency} {Number(100).toFixed(2)}
            {" Due "}
            {"January 28, 2025"}
          </Text>
        </View> */}

        <View style={styles.Table}>
          <View style={styles.Row}>
            <Text style={[styles.Cell, styles.Text, styles.Bold, styles.Width50]}>Description</Text>
            <Text style={[styles.Cell, styles.Text, styles.Bold, styles.Width10]}>Qty</Text>
            <Text style={[styles.Cell, styles.Text, styles.Bold, styles.Width20]}>Unit Price</Text>
            <Text style={[styles.Cell, styles.Text, styles.Bold, styles.TextRight, styles.Width20]}>Amount</Text>
          </View>
          <View style={styles.Row}>
            <Text style={[styles.Cell, styles.Text, styles.TextLeft, styles.Width50]}>{title} / {interval}</Text>
            <Text style={[styles.Cell, styles.Text, styles.Width10]}>{invoiceData?.moreData?.subscriptionById?.quantity}</Text>
            <Text style={[styles.Cell, styles.Text, styles.Width20]}>{currency} {amount}</Text>
            <Text style={[styles.Cell, styles.Text, styles.TextRight, styles.Width20]}>{currency} {amount}</Text>
          </View>
        </View>

        <View style={styles.TotalSection}>
          <View style={styles.Width50}>
            <View style={styles.SectionRow}>
              <Text style={[styles.Text]}>Fee amount</Text>
              <Text style={[styles.Text]}>{currency} {Number(fee_amount.value).toFixed(2)}</Text>
            </View>
            <View style={styles.SectionRow}>
              <Text style={[styles.Text]}>Net amount</Text>
              <Text style={[styles.Text]}>
                {currency} {Number(net_amount.value).toFixed(2)}
              </Text>
            </View>
            <View style={styles.SectionRow}>
              <Text style={[styles.Text, styles.Bold]}>Total</Text>
              <Text style={[styles.Text, styles.Bold]}>{currency} {Number(gross_amount.value).toFixed(2)}</Text>
            </View>
          </View>
        </View>

        <View style={styles.Footer} fixed>
          <Text >&copy; {new Date().getFullYear()} Travey Club. All Rights Reserved.</Text>
        </View>
      </Page>
    </Document>
  )
};

export default Invoice;
